import React from 'react';
import "./news.css"
import NewsPic from "../news-pic/nawruz.jpg"
import { useTranslation } from 'react-i18next'; // Add this import

const News13 = () => {
    const { t } = useTranslation(); // Add this hook

    return (
        <div>
            <br/>
            <br/>
            <br/>
            <div class="news">
                <article class="news-item">
                    <div class="news-item__date">
                        <svg class="news-item__date-icon" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#718096" stroke-width="2">
                            <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
                            <line x1="16" y1="2" x2="16" y2="6" />
                            <line x1="8" y1="2" x2="8" y2="6" />
                            <line x1="3" y1="10" x2="21" y2="10" />
                        </svg>
                        21.03.2025
                    </div>

                    <h2 class="news-item__title">
                        {t('news15.title')}
                    </h2>

                    <div class="news-item__content">
                        
                        <p>{t('news15.content')}</p>
                        <br/>
                        <p>{t('news15.content2')}</p>
                        <br/>
                        <br/>
                        <p>{t('news15.content3')}</p>
                        <p>{t('news15.content4')}</p>
                        <p>{t('news15.content5')}</p>
                        <p>{t('news15.content6')}</p>
                        <p>{t('news15.content7')}</p>
                        <p>{t('news15.content8')}</p>
                        <br/>
                        <p>{t('news15.content9')}</p>
                    </div>
                  

                    <div class="news-item__gallery">
                        <div class="news-item__image">
                            <img src={NewsPic} alt={t('news2.imageAlt')} />
                        </div>
                       
                    </div>
                    
                </article>
            </div>
        </div>
    );
}

export default News13;